export type InstallAppContentType = {
  MainBlockTitle: string;
  MainBlockImg: string;
  MainBlockImgMob: string;
  MainBlockBtnPc: string;
  MainBlockBtnMob: string;
  MainBlockGeneralBtn: string;
  MainBlockDesc1: string;
  MainBlockDesc2: string;
  SnackTitle: string;
  SnackSubtitle: string;
  SnackBtn: string;
  SideLinkName: string;
}
export const InstallationInstructionPlatformEnum = {
  PWA_NOT_AVAILABLE: 'PWA_NOT_AVAILABLE',
  IOS_SAFARI: 'IOS_SAFARI',
  IOS_CHROME: 'IOS_CHROME',
  IOS_INTERNAL_COPY: 'IOS_INTERNAL_COPY',
  IOS_INTERNAL_HOLD: 'IOS_INTERNAL_HOLD',
  ANDROID_INTERNAL: 'ANDROID_INTERNAL',
  MACOS: 'MACOS',
  DESKTOP_QR: 'DESKTOP_QR',
  IOS_26_SAFARI: 'IOS_26_SAFARI',
  ANDROID: 'ANDROID',
}

export type InstallationInstructionPlatformType = typeof InstallationInstructionPlatformEnum[keyof typeof InstallationInstructionPlatformEnum];

export type InstallGuidePlatformItem = {
  title?: string;
  desc?: string;
  text?: string;
  btnName?: string;
  btnIcon?: string;
  toastInfo?: string;
  step1?: string;
  step1Creative?: string;
  step1Between?: string;
  step1AfterTextIcon?: string;
  step1InCreativeIcon?: string;
  step1AfterCreativeIcon?: string;
  step2?: string;
  step2Creative?: string;
  step2Between?: string;
  step2AfterTextIcon?: string;
  step2InCreativeIcon?: string;
  step2AfterCreativeIcon?: string;
  step3?: string;
  step3Creative?: string;
  step3Between?: string;
  step3AfterTextIcon?: string;
  step3InCreativeIcon?: string;
  step3AfterCreativeIcon?: string;
  step4?: string;
  step4Creative?: string;
  step4Between?: string;
  step4AfterTextIcon?: string;
  step4InCreativeIcon?: string;
  step4AfterCreativeIcon?: string;
};

export type PwaNotAvailableItem = {
  title: string;
  desc: string;
  text: string;
  btnName: string;
};

export type InstallGuideByPlatformMap = {
  IOS_SAFARI: InstallGuidePlatformItem;
  IOS_CHROME: InstallGuidePlatformItem;
  IOS_INTERNAL_COPY: InstallGuidePlatformItem;
  IOS_INTERNAL_HOLD: InstallGuidePlatformItem;
  ANDROID_INTERNAL: InstallGuidePlatformItem;
  MACOS: InstallGuidePlatformItem;
  DESKTOP_QR: InstallGuidePlatformItem;
  IOS_26_SAFARI: InstallGuidePlatformItem;
  ANDROID: InstallGuidePlatformItem;
};

export type InstallationInstructionModalData = {
  title?: string;
  data?: InstallGuidePlatformItem | null;
  platformKey?: InstallationInstructionPlatformType;
  video?: string | null;
  instruction?: {
    GuideByPlatform?: Record<string, InstallGuidePlatformItem>;
    PwaNotAvailable?: {
      PwaNotAvailable?: InstallGuidePlatformItem;
    };
    VideoIosSafari?: string;
    VideoIosSafari26?: string;
    VideoIosChrome?: string;
    VideoMac?: string;
    VideoAndroid?: string;
    QrCodeImage?: string;
  } | null;
};

export type InstructionStepIndex = 1 | 2 | 3 | 4;

export type ResolvedInstructionStep = {
  index: InstructionStepIndex;
  text?: string;
  between?: string;
  creative?: string;
};

export type InstructionStepIconPlaces = {
  afterText?: string;
  inCreativeBlock?: string;
  afterCreative?: string;
  isIconBorder?: boolean;
};

export type ActionIconsMap = {
  left?: string;
  right?: string;
};
